<template>
  <b-modal
    ref="modal"
    header-bg-variant="primary"
    header-class="text-white"
    no-close-on-backdrop
  >
    <template #modal-header>
      <h3>
        <i class="ifr if-check text-success mr-3"></i
        >{{ $t("success.formular_saved.headline") }}
      </h3>
    </template>
    <b-row>
      <b-col cols="12">
        <p>
          {{ $t("success.formular_saved.text") }}
        </p>
      </b-col>
    </b-row>
    <template #modal-footer>
      <b-row>
        <b-col cols="12" class="text-center">
          <b-button
            v-show="!hideClose"
            variant="secondary"
            @click="$refs.modal.hide()"
          >
            {{ $t("actions.close") }}
          </b-button>
          <router-link class="btn btn-primary" :to="{ name: 'scan' }">
            {{ $t("actions.to_scan") }}
          </router-link>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
  export default {
    name: "SpeichernErfolgreichModal",
    beforeRouteLeave(to, from, next) {
      this.$refs.modal.hide();
      next();
    },
    data() {
      return {
        hideClose: true,
      };
    },
    methods: {
      show(hideClose = true) {
        this.hideClose = hideClose;
        this.$refs.modal.show();
      },
    },
  };
</script>

<style>
</style>
